module.exports = __webpack_public_path__ + "img/live-tablet.dbee0572.png";